<template>
	<div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogConstat" transition="dialog-bottom-transition" scrollable :loading="loading" max-width="100%" persistent>
            <v-card>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Effectuer le diagnostique pour la demande d'intervention {{demandeDetail.ref}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-container fluid grid-list-md>
                  <v-stepper v-model="e1">
                      <v-stepper-header>
                          <v-stepper-step :complete="e1 > 1" step="1">Description Diagnostique</v-stepper-step>
                          <v-divider></v-divider>
                          <v-stepper-step :complete="e1 > 2" step="2">Besoin materiel en stock</v-stepper-step>
                          <v-divider></v-divider>
                          <v-stepper-step :complete="e1 > 3" step="3">Besoins materiels fourni par le garage</v-stepper-step>
                      </v-stepper-header>

                      <v-stepper-items>
                          <v-stepper-content step="1">
                              <v-layout wrap>
                                  <v-flex xs12>
                                      <v-card class="mb-5"  color=""  height="auto" flat>
                                          <v-flex xs12  >
                                                  <el-form id="formRapportDiag" style="width:100%" :rules="ruleEtape1"   :model="formRapport"  ref="formRapport" class="demo-form-inline" >
                                                      <v-layout row >
                                                          <v-flex xs3 >
                                                              <v-layout row>
                                                                  <v-flex xs4 class="" >
                                                                      <v-avatar :tile="true" size="150px" height="120px" color="grey lighten-4"> <img :src="image1" alt="avatar"></v-avatar>
                                                                      <v-layout row>
                                                                          <input name="fileDevis" type="file" style="display:none" ref="file1" accept="image/*" @change="onFileImage1Picked"/>
                                                                          <v-btn color="primary" class="white--text" required @click.native="$refs.file1.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn>
                                                                          <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 2 Mo maximale</div>
                                                                      </v-layout>
                                                                  </v-flex>
                                                              </v-layout>
                                                          </v-flex>

                                                      <v-flex xs8 >
                                                          <v-layout row>
                                                              <v-flex xs4 class="mr-1 mt-1" >
                                                                <span class="demonstration">Garage *</span>
                                                                    <el-select clearable allow-create filterable v-model="selectGarage" name="garage" placeholder="nom du garage" class="mt-3" style="width:100%">
                                                                      <el-option v-for="item in listGarage" :key="item.id" :label="item.libelle" :value="item.id">
                                                                      </el-option>
                                                                  </el-select>
                                                              </v-flex>

                                                              <v-flex xs4 class="mr-1" >
                                                                  <el-form-item label="Main d'oeuvre (FCFA) *"  >
                                                                          <el-input type="number" :min="0"  v-model="formRapport.mainDoeuvre" ></el-input>
                                                                  </el-form-item>
                                                              </v-flex>

                                                              <v-flex xs4 class="mr-1" >
                                                                  <el-form-item label="Caisse *"   >
                                                                    <el-select clearable v-model="formRapport.selectCaisse" placeholder="Caisse *" style="width:100%" >
                                                                        <el-option v-for="item in listCaisse" :key="item.id" :label="item.libelle" :value="item.id">
                                                                        </el-option>
                                                                    </el-select>
                                                                  </el-form-item>
                                                              </v-flex>

                                                          </v-layout>
                                                          <v-layout row>
                                                              <v-flex xs4 class="mr-1" >
                                                                  <el-form-item label="Date du diagnostique *"  >
                                                                      <el-date-picker v-model="formRapport.dateDiag" format="d-MM-yyyy" value-format="yyyy-MM-d"  type="date" placeholder="Date de fin *" style="width: 100%" ></el-date-picker>
                                                                  </el-form-item>
                                                              </v-flex>
                                                              <v-flex xs6 class="mr-1" >
                                                                  <el-form-item label="rapport du diagnostique *"  >
                                                                      <el-input type="textarea" v-model="tabDiagnostique" ></el-input>
                                                                  </el-form-item>
                                                              </v-flex>
                                                          </v-layout>
                                                      </v-flex>
                                                  </v-layout>
                                                  </el-form>
                                              </v-flex>
                                      </v-card>
                                  </v-flex>
                              </v-layout>
                              <v-layout row>
                                  <v-spacer></v-spacer>
                                      <v-btn flat>Annuler</v-btn>
                                      <v-btn color="primary" @click="etape2('formRapport')">Suivant</v-btn>
                              </v-layout>
                          </v-stepper-content>

                          <v-stepper-content step="2">
                              <v-card class="mb-5" color="" height="400px" flat >
                                  <v-layout wrap>
                                      <v-flex xs6 class="mr-1" >
                                              <el-select clearable @change="handleChangeEntrepot()" v-model="formRapport.entrepot" placeholder="Selectionner un Entrepot *" style="width:100%" >
                                                  <el-option v-for="item in listEntrepot" :key="item.id" :label="item.libelle" :value="item.id">
                                                  </el-option>
                                              </el-select>
                                      </v-flex>
                                      <v-flex xs12>
                                          <v-card flat>
                                              <el-form id="formProduit" :rules="ruleFormProduit" ref="refFormProduit"  label-position="top" :inline="true" :model="formProduit" class="demo-form-inline">
                                                  <v-layout row >
                                                      <v-flex md5>
                                                          <el-form label="Désignation" prop="designation" >
                                                              <el-select clearable filterable @change="handleChangePrix()"  style="width:100%" v-model="formProduit.idProd" placeholder="Select">
                                                                  <el-option
                                                                          v-for="item in listStock"
                                                                          :key="item.idProduit"
                                                                          :label="item.produit"
                                                                          :value="item.idProduit">
                                                                  </el-option>
                                                              </el-select>
                                                          </el-form>
                                                      </v-flex>

                                                      <v-flex md3>
                                                          <el-form label="Quantite"  prop="quantite">
                                                              <el-input-number  :disabled="validConstat" :min="1" size="large" controls-position="right"   v-model="formProduit.quantite" placeholder="quantite" ></el-input-number>
                                                          </el-form>
                                                      </v-flex>

                                                      <v-flex md3  v-show="validConstat">
                                                          <el-form label="Prix Unitaire(FCFA)" prop="prixU">
                                                              <el-input-number  :min="5" disabled size="large" controls-position="right"    v-model="formProduit.prixUnit" placeholder="prix unitaire(HT)"  style="width:100%"></el-input-number>
                                                          </el-form>
                                                      </v-flex>

                                                      <v-flex md3>
                                                          <el-form label="Unite" prop="unite">
                                                              <el-input  size="large" disabled    v-model="formProduit.unite" placeholder=""  style="width:100%"></el-input>
                                                          </el-form>
                                                      </v-flex>

                                                      <v-flex md3>
                                                          <el-form label="-" >
                                                              <el-button   type="primary" @click="addListProduit('refFormProduit',formProduit)">Ajouter</el-button>
                                                              </el-form>
                                                      </v-flex>
                                                  </v-layout>
                                              </el-form>

                                              <v-spacer></v-spacer>
                                              <v-layout row>
                                                      <el-table :data="tableProduit" style="width: 100%" >
                                                          <el-table-column prop="designation" label="Designation" sortable> </el-table-column>
                                                          <el-table-column prop="quantite" label="Quantite"> </el-table-column>
                                                          <el-table-column  prop="prixU" label="Prix Unitaire(FCFA)"></el-table-column>
                                                          <el-table-column prop="unite" label="unite"> </el-table-column>
                                                          <el-table-column  prop="mntTotal" label="Total(Fcfa)"> </el-table-column>
                                                          <el-table-column   label="Operations">
                                                              <template slot-scope="scope">
                                                                  <v-tooltip top>
                                                                      <v-btn   slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableProduit)" dark>
                                                                          <v-icon center>delete</v-icon>
                                                                      </v-btn>
                                                                      Supprimer ce produit
                                                                  </v-tooltip>
                                                              </template>
                                                          </el-table-column>
                                                      </el-table>
                                              </v-layout>
                                          </v-card>
                                      </v-flex>
                                  </v-layout>
                              </v-card>
                              <v-layout row>
                                  <v-spacer></v-spacer>
                                  <v-btn color="primary" @click="e1 = 1">
                                      Précédent
                                  </v-btn>
                                  <v-btn color="green" dark @click="etape3()" >
                                      Suivant
                                  </v-btn>
                                  </v-layout>
                          </v-stepper-content>

                          <v-stepper-content step="3">
                              <v-card class="mb-5" color="" height="400px" flat >
                                  <v-layout row>
                                      <v-flex xs12>
                                          <v-card flat>
                                              <el-form  id="formProduitFour" :rules="ruleFormProduitFour" ref="refFormProduitFour"  label-position="top" :inline="true" :model="formProduitFour" class="demo-form-inline">
                                                    <v-layout row >
                                                      <v-flex md3>
                                                          <el-select
                                                                v-model="typeProduit" v-on:change="loadTypeProduit(typeProduit)"
                                                                placeholder="Type ressource"
                                                                style="width:100%"
                                                              >
                                                                <el-option
                                                                  v-for="item in typeProd"
                                                                  :key="item.value"
                                                                  :label="item.text"
                                                                  :value="item.id"
                                                                >
                                                                </el-option>
                                                          </el-select>
                                                        </v-flex>
                                                      </v-layout>
                                                      <br/>

                                                      <v-layout row >
                                                      <v-flex md3>
                                                          <el-form label="Désignation" prop="designation" >
                                                               <el-select clearable allow-create filterable v-model="formProduitFour.designation" placeholder="Désignation" style="width:100%">
                                                                  <el-option v-for="item in listProd" :key="item.id" :label="item.value" :value="item.id">
                                                                  </el-option>
                                                              </el-select>
                                                              <!-- <el-autocomplete  v-model="formProduitFour.designation" name="produitGarage" placeholder="designation du produit"  style="width: 100%" :fetch-suggestions="loadProduitGarage" ></el-autocomplete> -->
                                                          </el-form>
                                                      </v-flex>

                                                      <v-flex md3>
                                                          <el-form label="Quantite"  prop="quantite">
                                                              <el-input-number  :min="1" size="large" controls-position="right"   v-model="formProduitFour.quantite" placeholder="quantite" ></el-input-number>
                                                          </el-form>
                                                      </v-flex>

                                                      <v-flex md3  >
                                                          <el-form label="Prix Unitaire(FCFA)" prop="prixU">
                                                              <el-input-number  :min="5"  size="large" controls-position="right"    v-model="formProduitFour.prixUnit" placeholder="prix unitaire(HT)"  style="width:100%"></el-input-number>
                                                          </el-form>
                                                      </v-flex>

                                                      <v-flex md3>
                                                          <el-form label="Unite" prop="unite">
                                                              <el-input size="large"  v-model="formProduitFour.unite" placeholder="Unité"  style="width:100%"></el-input>
                                                          </el-form>
                                                      </v-flex>

                                                      <v-flex md3>
                                                          <el-form label="''" >
                                                              <el-button   type="primary" @click="addListProduitFour('refFormProduitFour',formProduitFour)">Ajouter</el-button>
                                                              </el-form>
                                                      </v-flex>
                                                  </v-layout>

                                              </el-form>

                                              <v-spacer></v-spacer>
                                              <v-layout row>
                                                      <el-table :data="tableProduitFour" style="width: 100%" >
                                                          <el-table-column prop="designation" label="Designation" sortable> </el-table-column>
                                                          <el-table-column prop="quantite" label="Quantite"> </el-table-column>
                                                          <el-table-column prop="prixU" label="Prix Unitaire(FCFA)"></el-table-column>
                                                          <el-table-column prop="unite" label="unite"> </el-table-column>
                                                          <el-table-column prop="mntTotal" label="Total(Fcfa)"> </el-table-column>
                                                          <el-table-column label="Operations">
                                                              <template slot-scope="scope">
                                                                  <v-tooltip top>
                                                                      <v-btn   slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableProduitFour)" dark>
                                                                          <v-icon center>delete</v-icon>
                                                                      </v-btn>
                                                                      Supprimer ce produit
                                                                  </v-tooltip>
                                                              </template>
                                                          </el-table-column>
                                                      </el-table>
                                              </v-layout>
                                          </v-card>
                                      </v-flex>
                                  </v-layout>
                              </v-card>
                              <v-layout row>
                                  <v-spacer></v-spacer>
                                  <v-btn color="primary" @click="e1 = 2">
                                      Précédent
                                  </v-btn>
                                  <v-btn @click="submitForm()" color="green" dark >
                                      Enregistrer <v-icon right>save</v-icon>
                                  </v-btn>

                                  </v-layout>
                          </v-stepper-content>
                      </v-stepper-items>
                  </v-stepper>
                  </v-container>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- CONFIRMATION VALIDATION -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogConfirm" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Validation du devis pour une demande de maintenance</v-card-title>
                <v-card-text>Voulez vous valider le devis ?</v-card-text>
                <v-flex xs12 class="mb-2 ml-1 mr-1">
                     <el-alert v-if="demandeDetail.entrepot != null"
                        title="Aucun entrepot défini dans la zone "
                        :description="'Pour générer un bon de sortie vous devez définir un entrepot pour la zone '+demandeDetail.libZone"
                        :closable="false"
                        show-icon
                        type="warning">
                    </el-alert>
                </v-flex>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click.native="dialogConfirm = false">Annuler</v-btn>
                <v-btn color="green darken-1" flat @click.native="SubmitValideDevis()">Confirmer</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>
          <v-layout row justify-center>
            <v-dialog v-model="dialogConfirmRefus" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Validation du devis pour une demande de maintenance</v-card-title>
                <v-card-text>
                    <el-form :disabled="validConstat" id="formRefus" :rules="ruleFormRefus" ref="refFormRefust"  label-position="top" :inline="true" :model="formRefus" class="demo-form-inline">
                     <v-flex xs12 >
                        <el-form-item style="width:100%" label="Voulez vous Refuser ce devis ?" prop="rapportRefus" >
                            <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Pourquoi voulez-vous refuser ?" v-model="formRefus.rapport"></el-input>
                        </el-form-item >
                    </v-flex>
                    </el-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click.native="dialogConfirmRefus = false">Annuler</v-btn>
                <v-btn color="green darken-1" flat @click.native="SubmitRefusDevis()">Confirmer</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>
          <!-- RACOURCIS -->
	</div>
</template>


<script>
    import Loading from '@/components/Loading';
    export default {
	components:{ Loading },
        name: "AjoutDiagIntervention",
         props: {
            show:{
                type: Boolean,
                default: false
            },
             demandeDetail: {
                 type: Object
             },
             validConstat: {
                 type: Boolean,
                 default: false
             }
         },
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            listeProduit: [],
            listStock: [],
            formRapport: {},
            formRefus:{},

            rapport:"",
            dialogConstat: false,
            dialogConfirm: false,
            dialogConfirmRefus:false,
            tableProduit: [],
            tableProduitFour: [],
            totalTTC: 0,
            fileList: [],
             dialogImageUrl: '',
             formProduit: {},
            dialogVisible: false,
            //image
            image1: "/static/img-doc.png",
            image2: "/static/img-doc.png",
            image3: "/static/img-doc.png",
            image4: "/static/img-doc.png",
            file1: "",
            file2: "",
            file3: "",
            listProd:[],
            typeProduit:'',
            typeProd: [
                { text: "Matériel", value: "MATÉRIEL", id: "1" },
                { text: "Matériaux", value: "MATÉRIAUX", id: "2" },
                { text: "Service", value: "SERVICE", id: "3" },
                { text: "Véhicule", value: "VÉHICULE", id: "4" },
                { text: "Autre", value: "AUTRE", id: "5" },
                { text: "Fourniture", value: "FOURNITURE", id: "6" },
                { text: "Personnel", value: "PERSONNEL", id: "7" },
                { text: "Pièces détachées", value: "PIECES DETACHEES", id: "8" }
            ],

            ruleFormProduit: {
                idProd: [
                    { required: true, message: 'Veuillez saisir' },
                ],
                quantite: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            },
             formProduitFour: {},
             ruleFormProduitFour: {
                designation: [
                    { required: true, message: 'Veuillez saisir' },
                ],
                quantite: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            },
             ruleFormRefus: {
                rapportRefus: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            },
             //info intervention
            listPrestataire: [],
            listCaisse: [],
            tabDiagnostique:[],
            selectGarage:'',
            e1: 0,
            ruleEtape1: {
                     tel1: [
                        { required: true, message: 'Veuillez remplir ce champ', trigger: 'blur' },
                    ],
                },
            commandeDeriv:[],
            listEntrepot:[],
            listGarage:[]
         }//return


        }, //data

        computed:{

        },
         watch: {
            show: function(newValue,oldValue){
                if(newValue == true){
                    this.dialogConstat= true
                    this.loadCaisse()
                    this.resetForm()
                }else{
                    this.dialogConstat =false;
                }
            }
        },

        methods: {
            loadEntrepot ()
        {
            let url = this.domaine + 'entrepot/index'
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.listEntrepot = response.body.entrepot
                }
            })
        },

            onFileImage1Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image1 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file1 = files[0]
            },
         //enregistrement des images
        onFileImage2Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image2 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file2 = files[0]
            },

         //enregistrement des images
        onFileImage3Picked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image3 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file3 = files[0]
            },
            handleSuccess(response, file, fileList){
                    this.fileList.push(file)
            },
            handlePictureCardPreview(file, fileList) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
             closeDialog(){
                this.$emit('close')
            },
            addListProduit(formName,item){
                this.$refs[formName].validate((valid) => {
                    if (valid)
                    {
                      let libelle = ''
                      let unite = ''
                      this.listStock.find((produit)=>{
                        if(produit.idProduit === item.idProd){
                          libelle= produit.produit
                          unite= produit.unite
                        }
                      })
                        this.tableProduit.push({
                          designation : libelle,
                          quantite : item.quantite,
                          unite: unite ? unite : 'pcs',
                          prixU :  item.prixUnit ,
                          mntTotal: parseInt(item.quantite) * parseInt(item.prixUnit)
                        })
                        this.totalTTC += parseInt(item.quantite) * parseInt(item.prixUnit)
                        // reinitilisation des champs
                        this.formProduit.prixUnit = 0
                        this.formProduit.unite = ""
                        this.formProduit.idProd = ""
                        this.formProduit.quantite = ""
                        // this.resetForm()
                    }
                })
            },

             addListProduitFour(formName,item){
                this.$refs[formName].validate((valid) => {
                    if (valid)
                    {
                        this.tableProduitFour.push({
                        designation : item.designation,
                        quantite : item.quantite,
                        unite: item.unite ? item.unite : 'pcs',
                        prixU :  item.prixUnit ,
                        mntTotal: parseInt(item.quantite) * parseInt(item.prixUnit)
                        })
                        this.totalTTC += parseInt(item.quantite) * parseInt(item.prixUnit)
                        // reinitilisation des champs
                        this.formProduitFour.prixUnit = 5
                        this.formProduitFour.quantite = 5
                        this.formProduitFour.unite = ""
                        this.formProduitFour.designation = ""
                        // this.resetForm()
                    }
                })
            },

             deleteRow(index, rows) {
                 let item = rows.splice(index, 1);
                this.totalTTC -= parseInt(item[0].mntTotal)
            },

            submitForm()
            {
                //analyse des prix des produits
                this.loading = true
                let url = this.domaine + 'intervention/new/'+ this.demandeDetail.id +'/diagnostique'
                let form = document.getElementById('formRapportDiag')
                let data = new FormData(form)
                data.append("tableProduit",  JSON.stringify(this.tableProduit))
                data.append("tableProduitFour",  JSON.stringify(this.tableProduitFour))
                data.append("idUser",this.user.id)
                data.append('garage', this.selectGarage)
                data.append('caisse', this.formRapport.selectCaisse)
                data.append('dateDiag',this.formRapport.dateDiag)
                data.append('entrepot',this.formRapport.entrepot)
                data.append('diagnostique',this.tabDiagnostique)
                data.append('maindoeuvre',this.formRapport.mainDoeuvre)
                 this.$http.post(url, data).then(response => {
                    // this.resetChampsConstat()
                     this.dialogConstat = false
                     this.closeDialog()
                     this.loading = false
                     this.successNotif("L'enregistrement du diagnostique s'est bien deroule' ")
                },(erreurRep) => {
                     this.loading = false
                    this.$message.error("Une erreur est survenue,Vérifier le contenu des différents champs de chaques étapes")
                })
            },

            loadProduit (){
            let url = this.domaine + 'product/load-product-stock'
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.listeProduit = response.body
                }
            })
            },

            loadProduitGarage(queryString, cb)
            {
                let url = this.domaine+ 'product/load-product-stock';
                this.$http.get(url).then(response => {
                  var links = response.body;
                  var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                  cb(results);
                },
                response => {
                })
            },

            loadDevisConstat ()
            {
            this.loading = true
            let url = this.domaine + 'demande_maintenance/devis/constat/'+this.demandeDetail.idDemande
            this.$http.get(url).then(response => {
                this.tableProduit = response.body.tableProduit
                this.formRapport.rapport = response.body.rapport
                this.totalTTC = response.body.total
                 this.loading = false
            },errResp=>{
                 this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la table des produits")
            })
            },
          handleChangeEntrepot(){
            this.loading = true
            let url = this.domaine + 'entrepot/stock/dispo/' + this.formRapport.entrepot
            this.$http.get(url).then(response => {
              this.loading =  false
              this.listStock = response.body.stock
            }, error => {
                this.loading =  false
                 this.$message.error("Une erreur est survenue lors du produit")
            })
            },
         handleChangePrix() {
             this.loading = true
            let url = this.domaine +  'maintenance/recherche/produit/'+this.formProduit.idProd
            this.$http.get(url).then(response => {
                    this.loading =  false
                    let produit = response.body.produit
                    this.formProduit.prixUnit  =  produit.valeur
                    this.formProduit.unite = produit.unite
            }, errReponse => {
                this.loading =  false
                this.formProduit.prixUnit=''
                  this.formProduit.unite = ''
                //  this.$message.error("Une erreur est survenue lors du produit")
            })
        },

        resetForm()
        {
          //reinitialisation des images telecharger
            this.image1 = "/static/img-doc.png";
            this.image2 = "/static/img-doc.png";
            this.image3 = "/static/img-doc.png";
            this.image = "/static/img-doc.png";
            this.file1 = "";
            this.file2 = "";
            this.file3 = "";
            this.selectGarage =''
            this.typeProduit = ''
            this.tabDiagnostique =[]
            this.e1 = 1
            this.formRapport={}
            this.tableProduitFour= []
            this.tableProduit = []
        },
         loadTypeProduit(item){
              if (this.$refs.typeProduit == "") {
                  return;
                }
                this.loading = true;
                let url = this.domaine + "product/productSelect/type/"+item;
                this.$http.get(url).then(
                  response => {
                    this.loading = false;
                    this.listProd = response.body.produits;
                  },
                  errRep => {
                    this.loading = false;
                    this.$message.error(
                      "Une erreur est survenue lors du chargement de la liste du chntier"
                    );
                  }
                );

              },
        successNotif(mess = "")
        {
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center'
                })
        },

        resetChampsConstat()
        {
              this.tableProduit.splice(0);
              this.totalTTC = 0;
              this.formRapport.rapport = ""
        },
        SubmitValideDevis(){
            this.loading = true
              let url = ""
            if(this.demandeDetail.etatDmd == 4){
                url = this.domaine + 'demande_maintenance/devis/validation2'
            }else {
                  url = this.domaine + 'demande_maintenance/devis/validation1'
            }

            let data = new FormData()
            data.append("idDemande",  this.demandeDetail.idDemande)
            data.append("idUser",  this.user.id)
            this.$http.post(url,data).then(response => {
            this.loading = false
            this.successNotif(response.body.message)
              this.dialogConfirm = false
              this.closeDialog();


        },errResp=>{
              this.loading = false
              this.$message.error("Une erreur est survenue lors de la validation du devis")
        })
        },
        SubmitRefusDevis(){
            //this.loading = true
            let url = this.domaine + 'demande_maintenance/devis/refuser'
            let data = new FormData()
            data.append("idDemande",  this.demandeDetail.idDemande)
            data.append("idUser",  this.user.id)
            data.append("rapport",  this.formRefus.rapport)

            this.$http.post(url,data).then(response => {
            this.loading = false
            this.successNotif(response.body.message)
              this.dialogConfirmRefus = false
            this.closeDialog();

        },errResp=>{
              this.loading = false
              this.$message.error("Une erreur est survenue lors du refus du devis")
        })
        },
        loadCaisse () {
            let url = this.domaine + 'caisse/index'
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.listCaisse = response.body.caisse
                }
            })
        },
        loadGarage() {
            let url = this.domaine +  'intervention/index/garage'
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.listGarage = response.body.garage;
                }
            },
            response => {
            })
        },
         createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        etape2()
        {
              if(this.selectGarage == undefined || this.selectGarage =='')
              {
                    this.$message.error("Selectionner un garage");
                    return;
              }
              if(this.formRapport.mainDoeuvre == undefined)
              {
                    this.$message.error("Saisir la main d'oeuvre");
                    return;
              }
              if(this.formRapport.selectCaisse == undefined)
              {
                    this.$message.error("Selectionner une caisse");
                    return;
              }
                if(this.formRapport.dateDiag == undefined)
              {
                    this.$message.error("Selectionner la date du diagnostique");
                    return;
              }
              if(this.tabDiagnostique  == undefined || this.tabDiagnostique.length == 0){
                    this.$message.error("Veuillez saisir ue description dans le champs rapport");
                    return;
              }

            this.e1 = 2;

        },
        etape3(){
            if(this.tableProduit.length > 0 && this.formRapport.entrepot == undefined){
                  this.$message.error("Veuillez selectionner un entrepot pour la sortie du matériel");
                    return;
            }
            this.e1 = 3;
        }
        }, //mthods
        mounted(){
             this.loadProduit();
             this.loadEntrepot();
             this.loadGarage()
        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/intervention/AjoutDiagIntervention.vue